import * as React from 'react';
import type { SVGProps } from 'react';

interface SideMenuArrowProps extends SVGProps<SVGSVGElement> {
  circleFill?: string;
}

export const SideMenuArrow = ({ circleFill = '#333', ...props }: SideMenuArrowProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="20" height="20" rx="10" fill={circleFill} />
    <path d="M9.99994 5L15.1961 12.875H4.80379L9.99994 5Z" fill="#fff" />
  </svg>
);
